/**
 * NXCHIEN 30.03.2022 Loại tiền lương
 */
export default {
  IncomRecurrent: 1,    // Thu nhập thường xuyên
  IncomCasual: 2,       // Thu nhập không thường xuyên
  OutcomRecurrent: 3,   // Khấu trừ thường xuyên
  OutcomCasual: 4,      // Khấu trừ không thường xuyên
};
